import { useEffect, useRef } from "react";
import { useMotionValue, useSpring, useTransform, animate, motion } from "framer-motion";

export default function AnimatedCounter({ value }) {
  // Track if this is the very first time we are receiving a non-zero value
  const isInitialRender = useRef(true);
  const count = useMotionValue(0);
  
  const springValue = useSpring(count, {
    stiffness: 45,
    damping: 15,
  });

  const displayValue = useTransform(springValue, (latest) => 
    Math.round(latest).toLocaleString()
  );

  useEffect(() => {
    // If we have a real value and it's the first time the component "sees" it
    if (isInitialRender.current && value > 0) {
      // Start the animation from a point close to the total (e.g., current total minus 50)
      // We use Math.max(0, ...) to ensure we never start at a negative number
      const startPoint = Math.max(0, value - 50);
      
      count.set(startPoint); 
      isInitialRender.current = false;
    }

    // Animate from the startPoint (or current position) to the latest value
    const controls = animate(count, value, { 
      duration: 2,
      ease: "easeOut" 
    });
    
    return () => controls.stop();
  }, [value, count]);

  return (
    <motion.span className="rh-counter-number">
      {displayValue}
    </motion.span>
  );
}